/* NAMA — custom product reviews section (nrv).
   Hydrates design-handoff markup from the Judge.me Review Widget DOM
   below it: the widget stays the source of truth (form, votes,
   pagination, lightbox) and the fallback surface. If parsing yields
   nothing while Judge.me reports reviews, the section stays hidden and
   the restyled stock widget remains — that contract is load-bearing. */

(function () {
  var section = document.getElementById('reviews');
  if (!section || !section.hasAttribute('data-nrv-pending')) return;

  var body = document.body;
  var VOTED_KEY = 'nrv-voted';
  var FIT_POS = { small: 15, true: 50, large: 85 };
  var store = [];        // parsed reviews, append-only, keyed by id
  var seen = {};
  var state = { photos: false, rating: 0, height: '', btype: '' };
  var activeSort = 'recent';

  // Tuck the stock widget away while we attempt hydration; restored on bail.
  body.classList.add('nrv-jdgm-tucked');

  // Judge.me scrolls toward its widget after async work (pagination fetches,
  // late setup). While the widget is tucked offscreen those scrolls would
  // yank the page to wherever the widget lives — swallow any scrollIntoView
  // aimed inside it. User scrolling and every other target stay native.
  var nativeSIV = Element.prototype.scrollIntoView;
  Element.prototype.scrollIntoView = function () {
    if (body.classList.contains('nrv-jdgm-tucked') &&
        !body.classList.contains('nrv-form-open') &&
        this.closest && this.closest('.product-app--container')) return;
    return nativeSIV.apply(this, arguments);
  };

  // Judge.me's revamp bundle (ReviewWidget-*.js) calls window.scrollTo
  // DIRECTLY after every pagination fetch — bypassing both scrollIntoView
  // and jdgm.scrollTo. With the widget tucked those calls tick the page
  // toward wherever the tuck happens to sit (traced 2026-07-28, stacks:
  // Se()/pe() in ReviewWidget-*.js). Swallow scrolls whose CALLER is their
  // bundle while tucked; every other scrollTo/scrollBy stays native.
  function fromJdgmBundle() {
    try { return /judge\.?me|ReviewWidget/i.test(new Error().stack || ''); }
    catch (e) { return false; }
  }
  var nativeWScrollTo = window.scrollTo.bind(window);
  window.scrollTo = function () {
    if (body.classList.contains('nrv-jdgm-tucked') &&
        !body.classList.contains('nrv-form-open') && fromJdgmBundle()) return;
    return nativeWScrollTo.apply(null, arguments);
  };
  var nativeWScrollBy = window.scrollBy.bind(window);
  window.scrollBy = function () {
    if (body.classList.contains('nrv-jdgm-tucked') &&
        !body.classList.contains('nrv-form-open') && fromJdgmBundle()) return;
    return nativeWScrollBy.apply(null, arguments);
  };

  // Community surfaces show real customer photos only: no badge icons, no
  // Artboard* marketing graphics riding on legacy reviews.
  function isCustomerPhoto(src) {
    // Product-catalog images (Shopify CDN) ride along on grouped reviews as
    // "reviewing this colour" thumbnails — only review-CDN uploads are UGC.
    if (/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) return false;
    var f = (src.split('/').pop() || '').toLowerCase();
    return !/\.svg(\?|$)/.test(f) && f.indexOf('artboard') === -1 &&
      f.indexOf('verified') === -1 && f.indexOf('icon') === -1;
  }

  // Judge.me ships two widget markups: classic (.jdgm-rev-widg / .jdgm-rev)
  // and the revamp (#judgeme_product_reviews .jm-review-item). Support both.
  function widget() {
    return document.querySelector('.product-app--container .jdgm-rev-widg') ||
      document.querySelector('.product-app--container .jdgm-widget-revamp, .product-app--container #judgeme_product_reviews');
  }
  function isRevamp(w) { return !w.classList.contains('jdgm-rev-widg'); }

  function bail() {
    body.classList.remove('nrv-jdgm-tucked');
    section.setAttribute('data-nrv-pending', '');
    if (observer) observer.disconnect();
  }

  /* ── parsing ─────────────────────────────────────────────── */

  function applyAnswer(out, q, a) {
    a = (a || '').replace(/^[\s:]+/, '').trim();
    if (!/[0-9a-z]/i.test(a)) return; // empty / punctuation-only answers
    var ql = q.toLowerCase();
    if (ql.indexOf('usual size') !== -1) out.meta['Usual size'] = a;
    else if (ql.indexOf('size did you order') !== -1) out.meta['Bought'] = a;
    else if (ql.indexOf('height') !== -1) out.meta['Height'] = a;
    else if (ql.indexOf('body type') !== -1) out.meta['Body type'] = a;
    else if (ql.indexOf('fit') !== -1) {
      var al = a.toLowerCase();
      out.fit = al.indexOf('small') !== -1 ? FIT_POS.small
        : al.indexOf('large') !== -1 ? FIT_POS.large : FIT_POS.true;
    }
  }

  // A Q/A row is the DEEPEST element whose text holds exactly one question
  // mark plus a non-empty answer. Containers can hold several rows (classic
  // widget packs multiple answers into one .jdgm-rev__custom-form), so never
  // treat a multi-question container as a single pair.
  function extractQARows(container, out) {
    var found = 0;
    var nodes = [].slice.call(container.querySelectorAll('*'));
    nodes.push(container);
    nodes.forEach(function (n) {
      var t = n.textContent.replace(/\s+/g, ' ').trim();
      if ((t.match(/\?/g) || []).length !== 1) return;
      var m = t.match(/^(.*?\?)\s*:?\s*(.+)$/s);
      if (!m) return;
      // deepest only: skip if a child element also qualifies
      var childQualifies = [].slice.call(n.children).some(function (ch) {
        var ct = ch.textContent.replace(/\s+/g, ' ').trim();
        return (ct.match(/\?/g) || []).length === 1 && /\?\s*:?\s*\S/.test(ct);
      });
      if (childQualifies) return;
      applyAnswer(out, m[1], m[2].trim());
      found++;
    });
    return found;
  }

  function parseCustomForms(rev) {
    var out = { meta: {}, fit: null };
    rev.querySelectorAll('.jdgm-rev__custom-form').forEach(function (cf) {
      extractQARows(cf, out);
    });
    return out;
  }

  function parseReview(rev) {
    var author0 = ((rev.querySelector('.jdgm-rev__author') || {}).textContent || '').trim();
    var body0 = ((rev.querySelector('.jdgm-rev__body') || {}).textContent || '').trim();
    var title0 = ((rev.querySelector('.jdgm-rev__title') || {}).textContent || '').trim();
    if (!author0 && !body0 && !title0) return null; // unrendered shell
    var id = 'jm:' + author0 + '|' + (body0 || title0).slice(0, 48);
    if (seen[id]) return null;
    var ratingEl = rev.querySelector('.jdgm-rev__rating');
    var pics = [];
    rev.querySelectorAll('.jdgm-rev__pics .jdgm-rev__pic-link, .jdgm-rev__pics a').forEach(function (a) {
      var img = a.querySelector('img');
      var src = img && (img.currentSrc || img.src || img.getAttribute('data-src'));
      if (src && isCustomerPhoto(src)) pics.push({ src: src, el: a });
    });
    var cf = parseCustomForms(rev);
    var dateText = (rev.querySelector('.jdgm-rev__timestamp') || {}).textContent || '';
    var r = {
      id: id,
      el: rev,
      stars: Number(ratingEl && ratingEl.getAttribute('data-score')) || 0,
      dateText: dateText.trim(),
      date: Date.parse((rev.querySelector('.jdgm-rev__timestamp') || {}).getAttribute
        ? (rev.querySelector('.jdgm-rev__timestamp').getAttribute('data-content') || dateText) : dateText) || 0,
      author: author0,
      verified: (rev.getAttribute('data-verified-buyer') || rev.getAttribute('data-verifiedbuyer')) === 'true',
      title: title0,
      bodyText: body0,
      helpful: Number(rev.getAttribute('data-thumb-up-count') || rev.getAttribute('data-thumbupcount')) || 0,
      voteTarget: rev.querySelector('.jdgm-rev__votes [class*="up"], .jdgm-rev__votes a, .jdgm-rev__votes button'),
      pics: pics,
      meta: cf.meta,
      fit: cf.fit
    };
    seen[id] = true;
    return r;
  }

  /* revamp (jm-*) adapter — no stable review id in the DOM, so key on
     author+date+title. Q/A rows read as "Question?Answer" text. */
  function parseRevampReview(rev) {
    var details = rev.querySelector('.jm-reviewer-info__details');
    var author = '', dateText = '';
    if (details && details.children.length) {
      author = details.children[0].textContent.trim();
      if (details.children.length > 1) dateText = details.children[1].textContent.trim();
    }
    var title = ((rev.querySelector('.jm-review-content__title') || {}).textContent || '').trim();
    var bodyText = ((rev.querySelector('.jm-review-content__body') || {}).textContent || '').trim();
    if (!author && !bodyText && !title) return null; // unrendered shell — retry on next mutation
    // date/title render late in the revamp widget — key on stable content
    var id = 'jm:' + author + '|' + (bodyText || title).slice(0, 48);
    if (seen[id]) return null;
    var aria = (rev.querySelector('.jm-star-rating') || { getAttribute: function () { return ''; } }).getAttribute('aria-label') || '';
    var stars = Number((aria.match(/([\d.]+)\s*out of/) || [])[1]) || 0;
    var pics = [];
    rev.querySelectorAll('img').forEach(function (img) {
      if (img.closest('[class*="avatar"]')) return;
      var src = img.currentSrc || img.src || img.getAttribute('data-src');
      if (src && isCustomerPhoto(src)) pics.push({ src: src, el: img.closest('button, a') || img });
    });
    var out = { meta: {}, fit: null };
    // Nesting depth varies: a Q/A row is the deepest element containing
    // exactly one question mark plus a non-empty answer after it.
    var list = rev.querySelector('.jm-custom-answer-list__content, [class*="custom-answer"]');
    if (list) {
      var rows = [].slice.call(list.querySelectorAll('*')).filter(function (n) {
        var t = n.textContent.replace(/\s+/g, ' ').trim();
        var marks = (t.match(/\?/g) || []).length;
        if (marks !== 1) return false;
        var m2 = t.match(/^(.*?\?)\s*(.+)$/s);
        if (!m2) return false;
        // deepest only: skip if a child element also qualifies
        return ![].slice.call(n.children).some(function (ch) {
          var ct = ch.textContent.trim();
          return (ct.match(/\?/g) || []).length === 1 && /\?.*\S/.test(ct.replace(/\s+/g, ' '));
        });
      });
      rows.forEach(function (row) {
        var m = row.textContent.replace(/\s+/g, ' ').trim().match(/^(.*?\?)\s*(.+)$/s);
        if (m) applyAnswer(out, m[1], m[2].trim());
      });
    }
    var r = {
      id: id, el: rev, stars: stars,
      dateText: dateText,
      date: Date.parse(dateText) || 0,
      author: author,
      verified: !!rev.querySelector('[class*="verified"]'),
      title: title,
      bodyText: bodyText,
      helpful: 0,
      voteTarget: rev.querySelector('[class*="thumb"], [class*="vote"], [class*="helpful"] button'),
      pics: pics, meta: out.meta, fit: out.fit
    };
    seen[id] = true;
    return r;
  }

  var byId = {};

  function harvest() {
    // The widget renders progressively (answer lists and photos can arrive
    // after the review shell), so re-parses must MERGE into known reviews,
    // not be dropped by the dedupe key.
    var w = widget();
    if (!w) return 0;
    var changed = 0;
    var items = isRevamp(w) ? w.querySelectorAll('.jm-review-item') : w.querySelectorAll('.jdgm-rev');
    items.forEach(function (rev) {
      var wasSeen = {};
      for (var k in seen) wasSeen[k] = true;
      seen = {};
      var r = isRevamp(w) ? parseRevampReview(rev) : parseReview(rev);
      seen = wasSeen;
      if (!r) return;
      var known = byId[r.id];
      if (!known) {
        seen[r.id] = true;
        byId[r.id] = r;
        store.push(r);
        changed++;
      } else {
        var grew = false;
        if (r.pics.length > known.pics.length) { known.pics = r.pics; grew = true; }
        if (r.fit != null && known.fit == null) { known.fit = r.fit; grew = true; }
        var keys = Object.keys(r.meta);
        for (var i = 0; i < keys.length; i++) {
          if (!known.meta[keys[i]]) { known.meta[keys[i]] = r.meta[keys[i]]; grew = true; }
        }
        known.el = r.el;
        known.voteTarget = r.voteTarget;
        if (grew) { changed++; refreshCard(known); }
      }
    });
    return changed;
  }

  // The grid is append-only (rebuilds under a reading user caused visible
  // ticks), so a card rendered before its review's custom-form answers
  // hydrated must be refreshed IN PLACE when the merge above grows it —
  // otherwise size/height/body-type meta stays missing forever (bit us on
  // classic-widget products: shells parse before answers render).
  function refreshCard(r) {
    if (!grid || !grid.children.length) return;
    [].slice.call(grid.children).forEach(function (c) {
      if (c.dataset && c.dataset.nrvId === r.id) grid.replaceChild(card(r), c);
    });
  }

  /* ── rendering ───────────────────────────────────────────── */

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function starRow(count) {
    var span = el('span', 'rv-stars');
    for (var i = 1; i <= 5; i++) {
      var svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      if (i > count) svg.setAttribute('class', 'empty');
      var p = document.createElementNS('http://www.w3.org/2000/svg', 'path');
      p.setAttribute('d', 'M12 2l2.9 6.3 6.9.8-5.1 4.7 1.4 6.8L12 18l-6 3.6 1.4-6.8L2.3 9.1l6.9-.8z');
      svg.appendChild(p);
      span.appendChild(svg);
    }
    return span;
  }

  function voted() {
    try { return JSON.parse(localStorage.getItem(VOTED_KEY) || '[]'); } catch (e) { return []; }
  }

  // Judge.me's lightbox needs the source node to still be in the widget's
  // current page; for photos from other pages, show a minimal ink overlay.
  function openPic(pic) {
    if (pic.el && pic.el.isConnected && pic.el.click) { pic.el.click(); return; }
    var scrim = el('div', 'nrv-lightbox');
    var img = el('img'); img.src = pic.src; img.alt = 'Customer photo';
    scrim.appendChild(img);
    scrim.addEventListener('click', function () { scrim.remove(); });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { scrim.remove(); document.removeEventListener('keydown', esc); }
    });
    document.body.appendChild(scrim);
  }

  // "2 weeks ago"-style date for the desktop track layout; CSS uppercases it
  function relDate(r) {
    if (!r.date) return r.dateText || '';
    var days = Math.floor((Date.now() - r.date) / 86400000);
    if (days < 0) return r.dateText || '';
    if (days === 0) return 'today';
    if (days < 14) return days + (days === 1 ? ' day ago' : ' days ago');
    if (days < 60) return Math.floor(days / 7) + ' weeks ago';
    if (days < 730) return Math.floor(days / 30) + ' months ago';
    return Math.floor(days / 365) + ' years ago';
  }

  function card(r) {
    var c = el('article', 'review-card');
    c.dataset.stars = r.stars;
    c.dataset.photos = r.pics.length ? 'true' : 'false';
    c.dataset.helpful = r.helpful;
    c.dataset.date = r.date;
    c.dataset.nrvId = r.id;

    // Two tracks (Shane 2026-07-28): desktop lays them side by side, full
    // section width; mobile flattens them via display:contents + order so
    // its layout is untouched.
    var lt = el('div', 'rv-track rv-track-l');
    var rt = el('div', 'rv-track rv-track-r');

    if (r.pics.length) {
      var ph = el('div', 'review-photo rv-photo-top');
      r.pics.slice(0, 3).forEach(function (pic) {
        var shot = el('span', 'shot');
        var img = el('img'); img.src = pic.src; img.alt = 'Customer photo'; img.loading = 'lazy';
        shot.appendChild(img);
        shot.addEventListener('click', function () { openPic(pic); });
        ph.appendChild(shot);
      });
      lt.appendChild(ph); // photo stays above the name (Shane)
    }

    var name = el('p', 'rv-name', r.author || 'Anonymous');
    if (r.verified) name.appendChild(el('span', 'verified', ' · Verified Buyer'));
    lt.appendChild(name);
    // absolute date = mobile (unchanged look); relative = desktop track
    if (r.dateText) lt.appendChild(el('p', 'rv-date-line rv-date-abs', r.dateText));

    var top = el('div', 'rv-top');
    top.appendChild(starRow(r.stars));
    lt.appendChild(top);

    var when = relDate(r);
    if (when) lt.appendChild(el('p', 'rv-date-line rv-date-rel', when));

    // Omit missing fields rather than printing placeholders (spec §5).
    // Meta gets its own track so ≥1024px lays it out as a third column —
    // answers align vertically and scan across reviews (Shane).
    var mt = el('div', 'rv-track rv-track-m');
    var metaKeys = ['Height', 'Usual size', 'Bought', 'Body type'];
    var metaVals = metaKeys.filter(function (k) { return r.meta[k]; });
    if (metaVals.length) {
      var meta = el('div', 'rv-meta');
      metaVals.forEach(function (k) {
        var d = el('div', null, k + ' ');
        d.appendChild(el('span', null, r.meta[k]));
        meta.appendChild(d);
      });
      mt.appendChild(meta);
    }

    if (r.title) rt.appendChild(el('p', 'rv-title', r.title));
    if (r.bodyText) rt.appendChild(el('p', 'rv-body', r.bodyText));

    if (r.fit != null) {
      var fit = el('div', 'rv-fit');
      fit.appendChild(el('div', 'rv-fit-label', 'Fit'));
      var track = el('div', 'rv-fit-track');
      var marker = el('span', 'rv-fit-marker');
      marker.style.left = r.fit + '%';
      track.appendChild(marker);
      fit.appendChild(track);
      var ends = el('div', 'rv-fit-ends');
      ['Small', 'True', 'Large'].forEach(function (t) { ends.appendChild(el('span', null, t)); });
      fit.appendChild(ends);
      rt.appendChild(fit);
    }

    // Helpful voting only when the widget exposes a real vote target —
    // an optimistic counter with nowhere to land would lie.
    if (r.voteTarget) {
      var foot = el('div', 'rv-foot');
      var helpful = el('span', 'rv-helpful');
      helpful.appendChild(el('span', null, 'Helpful?'));
      var btn = el('button', null, 'Yes (' + r.helpful + ')');
      btn.type = 'button';
      if (voted().indexOf(r.id) !== -1) btn.classList.add('voted');
      btn.addEventListener('click', function () {
        if (btn.classList.contains('voted')) return;
        r.voteTarget.click(); // real vote lands on Judge.me
        r.helpful += 1;
        btn.textContent = 'Yes (' + r.helpful + ')';
        btn.classList.add('voted');
        btn.setAttribute('aria-pressed', 'true');
        c.dataset.helpful = r.helpful;
        try {
          var v = voted(); v.push(r.id);
          localStorage.setItem(VOTED_KEY, JSON.stringify(v));
        } catch (e) { /* private mode */ }
      });
      helpful.appendChild(btn);
      foot.appendChild(helpful);
      rt.appendChild(foot);
    }
    c.appendChild(lt);
    c.appendChild(mt);
    c.appendChild(rt);
    return c;
  }

  // Body-type vocabulary spans eras: Okendo used Thin/Built, the new form
  // uses the 7-option shape set. Cards display what the reviewer said;
  // filters group via these aliases, and legacy generic "Curvy" matches
  // either curvy-on-top or curvy-on-bottom.
  var BTYPE_ALIAS = { thin: 'slim', built: 'athletic' };
  var BTYPE_LABELS = { slim: 'Slim', athletic: 'Athletic', average: 'Average',
    hourglass: 'Hourglass', 'curvy on top': 'Curvy on top',
    'curvy on bottom': 'Curvy on bottom', 'full-figured': 'Full-figured', curvy: 'Curvy' };
  function normBtype(v) {
    var k = (v || '').trim().toLowerCase();
    return BTYPE_ALIAS[k] || k;
  }

  function heightInches(r) {
    var h = r.meta['Height'] || '';
    var cm = h.match(/(\d{2,3})\s*cm/i);
    if (cm) return Math.round(Number(cm[1]) / 2.54);
    var m = h.match(/(\d)\s*['\u2018\u2019\u02BC]?\s*(\d{1,2})?/);
    if (!m) return 0;
    return Number(m[1]) * 12 + (Number(m[2]) || 0);
  }
  var HEIGHT_BUCKETS = [
    { key: 'u53', label: 'Under 5\u20323\u2033', min: 1, max: 62 },
    { key: 'b5356', label: '5\u20323\u2033 \u2013 5\u20326\u2033', min: 63, max: 66 },
    { key: 'b5710', label: '5\u20327\u2033 \u2013 5\u203210\u2033', min: 67, max: 70 },
    { key: 'o510', label: 'Over 5\u203210\u2033', min: 71, max: 120 }
  ];
  function heightBucket(r) {
    var inches = heightInches(r);
    if (!inches) return '';
    var b = HEIGHT_BUCKETS.filter(function (x) { return inches >= x.min && inches <= x.max; })[0];
    return b ? b.key : '';
  }
  function visible(r) {
    if (state.photos && !r.pics.length) return false;
    if (state.rating && r.stars !== state.rating) return false;
    if (state.height && heightBucket(r) !== state.height) return false;
    if (state.btype) {
      var nv = normBtype(r.meta['Body type']);
      var curvyFamily = nv === 'curvy' && state.btype.indexOf('curvy') === 0;
      if (nv !== state.btype && !curvyFamily) return false;
    }
    return true;
  }

  function sorted() {
    return store.slice().sort(function (a, b) {
      if (activeSort === 'helpful') return b.helpful - a.helpful;
      if (activeSort === 'highest') return b.stars - a.stars;
      if (activeSort === 'lowest') return a.stars - b.stars;
      return b.date - a.date;
    });
  }

  var grid = section.querySelector('[data-nrv-grid]');
  var displayLimit = 12;

  function renderGrid() {
    grid.textContent = '';
    var shown = 0;
    sorted().forEach(function (r) {
      if (!visible(r) || shown >= displayLimit) return;
      grid.appendChild(card(r));
      shown++;
    });
  }

  function renderSummary() {
    var fits = store.filter(function (r) { return r.fit != null; });
    var attrs = section.querySelector('[data-nrv-attrs]');
    if (fits.length) {
      var avg = fits.reduce(function (s, r) { return s + r.fit; }, 0) / fits.length;
      section.querySelector('[data-nrv-fit-marker]').style.left = Math.round(avg) + '%';
      attrs.hidden = false;
    } else {
      attrs.hidden = true; // spec §3: no fit data, no continuum
    }
  }

  function renderGallery() {
    var pics = [];
    store.forEach(function (r) { r.pics.forEach(function (p) { pics.push(p); }); });
    var wrap = section.querySelector('[data-nrv-gallery]');
    if (!pics.length) { wrap.hidden = true; return; }
    var row = section.querySelector('[data-nrv-gallery-row]');
    row.textContent = '';
    var maxShots = 7;
    pics.slice(0, maxShots).forEach(function (pic) {
      var b = el('button', 'rv-shot'); b.type = 'button';
      var img = el('img'); img.src = pic.src; img.alt = 'Customer photo'; img.loading = 'lazy';
      b.appendChild(img);
      b.addEventListener('click', function () { openPic(pic); });
      row.appendChild(b);
    });
    if (pics.length > maxShots) {
      var more = el('button', 'rv-shot more'); more.type = 'button';
      more.appendChild(el('span', null, '+' + (pics.length - maxShots)));
      more.addEventListener('click', galleryViewAll);
      row.appendChild(more);
    }
    section.querySelector('[data-nrv-gallery-label]').textContent =
      'From the community · ' + pics.length + ' photo' + (pics.length === 1 ? '' : 's');
    wrap.hidden = false;
  }

  // Judge.me scrolls the page toward the widget after pagination clicks.
  // The widget is tucked near the reviews block, so background preloads
  // were yanking readers down the page. Suppress scrollIntoView around
  // programmatic clicks and quietly restore position if a jump sneaks
  // through — but never fight a scroll the user started themselves.
  function quietClick(elm) {
    // The permanent scrollIntoView swallow (top of file) neutralises the
    // widget's scroll-after-fetch; no position guard — a guard pinned to a
    // stale y fights the user's own scrolling (learned the hard way).
    wrapJdgmScroll(); // jdgm may have loaded after the hydration poll ended
    try { elm.click(); } catch (e) { /* noop */ }
  }

  function nextPageLink() {
    var w = widget();
    if (!w) return null;
    var classic = w.querySelector('.jdgm-paginate a.jdgm-paginate__next-page, .jdgm-paginate__next-page');
    if (classic) return classic;
    // revamp: numbered pager — the button after the current/active page
    var pager = w.querySelector('[class*="pagination"]');
    if (!pager) return null;
    var btns = [].slice.call(pager.querySelectorAll('button'));
    // aria-current first — a disabled prev-arrow must not read as "current"
    var cur = btns.findIndex(function (b) { return b.getAttribute('aria-current') === 'page'; });
    if (cur === -1) cur = btns.findIndex(function (b) { return /current|active|selected/.test(b.className); });
    var next = btns.filter(function (b) { return /^\d+$/.test(b.textContent.trim()); })
      .find(function (b) { return cur > -1 && btns.indexOf(b) > cur; });
    return next || null;
  }

  function renderMore() {
    var totalVisible = store.filter(visible).length;
    section.querySelector('[data-nrv-more]').hidden =
      !(displayLimit < totalVisible || (!paginationBroken && nextPageLink()));
  }

  function menuOpen() {
    return !!section.querySelector('.rv-drop-menu:not([hidden])');
  }

  function appendNewCards() {
    var have = {};
    grid.querySelectorAll('.review-card').forEach(function (c) { have[c.dataset.nrvId] = true; });
    var shown = grid.children.length;
    sorted().forEach(function (r) {
      if (shown >= displayLimit || !visible(r) || have[r.id]) return;
      grid.appendChild(card(r));
      shown++;
    });
  }

  function renderAll() {
    renderSummary(); renderGallery();
    if (!menuOpen()) { renderControls(); refreshChipStates(); }
    if (grid.children.length) appendNewCards(); else renderGrid();
    renderMore();
  }

  function loadMore() {
    displayLimit += 12;
    var link = nextPageLink();
    if (link) quietClick(link); // observer harvests the new page
    renderGrid(); renderMore();
  }

  /* ── wiring ──────────────────────────────────────────────── */

  /* ── dropdown chips + sort menu (Alo-style) ─────────────── */
  var SORT_LABELS = { highest: 'Highest to Lowest Rating', lowest: 'Lowest to Highest Rating', helpful: 'Most Helpful', recent: 'Most Recent' };

  function closeMenus() {
    section.querySelectorAll('.rv-drop-menu').forEach(function (m) { m.hidden = true; });
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.rv-drop-wrap')) closeMenus();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeMenus(); });

  function buildMenu(wrap, options, current, onPick) {
    var menu = wrap.querySelector('.rv-drop-menu');
    menu.textContent = '';
    options.forEach(function (opt) {
      var b = el('button', 'rv-drop-item' + (String(opt.value) === String(current) ? ' current' : ''), opt.label);
      b.type = 'button';
      b.addEventListener('click', function () { closeMenus(); onPick(opt); });
      menu.appendChild(b);
    });
  }

  function drop(key) { return section.querySelector('[data-nrv-drop="' + key + '"]'); }

  function refreshChipStates() {
    var resetBtn = section.querySelector('[data-nrv-reset]');
    var photosBtn = section.querySelector('[data-nrv-photos]');
    var none = !state.photos && !state.rating && !state.height && !state.btype;
    if (resetBtn) resetBtn.classList.toggle('active', none);
    if (photosBtn) photosBtn.classList.toggle('active', state.photos);
    var r = drop('rating'), h = drop('height'), b = drop('btype');
    if (r) r.querySelector('.rv-drop-trigger').classList.toggle('active', !!state.rating);
    if (h) h.querySelector('.rv-drop-trigger').classList.toggle('active', !!state.height);
    if (b) b.querySelector('.rv-drop-trigger').classList.toggle('active', !!state.btype);
  }

  function chipLabel(wrap, base, value) {
    var t = wrap.querySelector('.rv-drop-trigger');
    t.innerHTML = (value ? base + ' \u00b7 ' + value : base) + ' <span class="rv-caret">\u2304</span>';
  }

  function renderControls() {
    var ratingWrap = drop('rating'), heightWrap = drop('height'), btypeWrap = drop('btype'), sortWrap = drop('sort');
    if (!ratingWrap) return;

    var stars = {};
    store.forEach(function (r) { if (r.stars) stars[r.stars] = true; });
    var starOpts = [{ value: 0, label: 'All ratings' }].concat(
      [5, 4, 3, 2, 1].filter(function (n) { return stars[n]; }).map(function (n) {
        return { value: n, label: n + ' \u2605' };
      }));
    if (starOpts.length > 1) {
      ratingWrap.hidden = false;
      buildMenu(ratingWrap, starOpts, state.rating, function (opt) {
        state.rating = Number(opt.value);
        chipLabel(ratingWrap, 'Rating', opt.value ? opt.label : '');
        update();
      });
    }

    var buckets = {};
    store.forEach(function (r) { var b = heightBucket(r); if (b) buckets[b] = true; });
    var hOpts = [{ value: '', label: 'All heights' }].concat(
      HEIGHT_BUCKETS.filter(function (b) { return buckets[b.key]; }).map(function (b) {
        return { value: b.key, label: b.label };
      }));
    if (hOpts.length > 1) {
      heightWrap.hidden = false;
      buildMenu(heightWrap, hOpts, state.height, function (opt) {
        state.height = opt.value;
        chipLabel(heightWrap, 'Height', opt.value ? opt.label : '');
        update();
      });
    }

    var freq = {};
    store.forEach(function (r) {
      var v = (r.meta['Body type'] || '').trim();
      if (!v) return;
      var k = normBtype(v);
      freq[k] = freq[k] || { n: 0, label: BTYPE_LABELS[k] || v };
      freq[k].n++;
    });
    var bOpts = [{ value: '', label: 'All body types' }].concat(
      Object.keys(freq).sort(function (a, b) { return freq[b].n - freq[a].n; }).map(function (k) {
        return { value: k, label: freq[k].label };
      }));
    if (bOpts.length > 1) {
      btypeWrap.hidden = false;
      buildMenu(btypeWrap, bOpts, state.btype, function (opt) {
        state.btype = opt.value;
        chipLabel(btypeWrap, 'Body type', opt.value ? opt.label : '');
        update();
      });
    }

    if (sortWrap) {
      buildMenu(sortWrap, ['highest', 'lowest', 'helpful', 'recent'].map(function (k) {
        return { value: k, label: SORT_LABELS[k] };
      }), activeSort, function (opt) {
        activeSort = opt.value;
        var lab = section.querySelector('[data-nrv-sort-label]');
        if (lab) lab.textContent = SORT_LABELS[activeSort];
        update();
      });
    }

    function update() { refreshChipStates(); renderControls(); renderGrid(); }

    section.querySelectorAll('.rv-drop-trigger, .rv-sort-trigger').forEach(function (t) {
      if (t.dataset.nrvWired) return;
      t.dataset.nrvWired = '1';
      t.addEventListener('click', function (e) {
        e.stopPropagation();
        var menu = t.parentElement.querySelector('.rv-drop-menu');
        var wasHidden = menu.hidden;
        closeMenus();
        menu.hidden = !wasHidden;
      });
    });

    var resetBtn = section.querySelector('[data-nrv-reset]');
    if (resetBtn && !resetBtn.dataset.nrvWired) {
      resetBtn.dataset.nrvWired = '1';
      resetBtn.addEventListener('click', function () {
        state = { photos: false, rating: 0, height: '', btype: '' };
        chipLabel(ratingWrap, 'Rating', '');
        chipLabel(heightWrap, 'Height', '');
        chipLabel(btypeWrap, 'Body type', '');
        update();
      });
    }
    var photosBtn = section.querySelector('[data-nrv-photos]');
    if (photosBtn && !photosBtn.dataset.nrvWired) {
      photosBtn.dataset.nrvWired = '1';
      photosBtn.addEventListener('click', function () {
        state.photos = !state.photos;
        update();
      });
    }
  }

  var moreBtn = section.querySelector('[data-nrv-more] button');
  if (moreBtn) moreBtn.addEventListener('click', loadMore);

  var writeBtn = section.querySelector('[data-nrv-write]');
  if (writeBtn) writeBtn.addEventListener('click', function () {
    var w = widget();
    var open = w && (w.querySelector('.jdgm-write-rev-link, [class*="write-rev"] button, [class*="write-rev"]') ||
      [].slice.call(w.querySelectorAll('button')).find(function (b) { return /write a review/i.test(b.textContent); }));
    if (open) open.click();

    // Judge.me's two markups host the form differently, so which one answered
    // decides what we do here:
    //   revamp  — opens its own position:fixed overlay modal. The widget must
    //             STAY tucked; revealing it drops the entire stock review list
    //             (~3100px) into the page under our section, which is the bug
    //             this replaced (Shane 2026-08-08).
    //   classic — renders the form INLINE inside the widget, so that one still
    //             needs the reveal and the scroll.
    // Poll briefly rather than assuming: the modal is built on click and a
    // single short timeout would race it on a slow connection.
    var tries = 0;
    (function awaitModal() {
      var modal = document.querySelector('.jdgm-write-review-modal, .jdgm-write-review-modal__overlay');
      if (modal && modal.getBoundingClientRect().height > 0) return; // modal path: leave tucked
      if (++tries < 12) { setTimeout(awaitModal, 60); return; }      // ~700ms grace
      body.classList.add('nrv-form-open');
      if (w) w.scrollIntoView({ behavior: 'smooth', block: 'start' });
    })();
  });

  var galleryAll = section.querySelector('[data-nrv-gallery-all]');
  function galleryViewAll() {
    if (!paginationBroken && nextPageLink()) { loadMore(); return; }
    // fully harvested: show every photo review in the grid
    state.photos = true;
    displayLimit = 10000;
    refreshChipStates(); renderControls(); renderGrid(); renderMore();
    grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  if (galleryAll) galleryAll.addEventListener('click', galleryViewAll);

  /* ── boot: wait for the widget to hydrate, then keep watching ── */

  var observer = null;
  var settled = false;

  function attempt() {
    var added = harvest();
    if (!store.length) return false;
    if (!settled) {
      settled = true;
      section.removeAttribute('data-nrv-pending');
    }
    if (added) renderAll();
    return true;
  }

  // After first hydration, quietly walk the hidden widget through ALL its
  // pages (capped) so the photo strip and filters see the whole group —
  // photo-heavy reviews are often many pages deep. The grid renders in
  // slices of 12 regardless, so this only enriches, never floods.
  var PRELOAD_PAGE_CAP = 25;
  var preloadClicks = 0;
  var paginationBroken = false;
  function preload() {
    if (paginationBroken || preloadClicks >= PRELOAD_PAGE_CAP) return;
    var link = nextPageLink();
    if (!link) return;
    var before = store.length;
    preloadClicks++;
    quietClick(link);
    setTimeout(function () {
      // Some Judge.me widget builds ship an inert pager (their classic/revamp
      // hybrid) — if a page click produced nothing, stop asking and drop the
      // dead Load-more button rather than showing a control that can't work.
      if (store.length === before && !nextPageChanged(link)) {
        paginationBroken = true;
        renderMore();
        return;
      }
      preload();
    }, 2500);
  }
  function nextPageChanged(prevLink) {
    var link = nextPageLink();
    return !link || link !== prevLink;
  }

  // Zero-review products: no hydration needed — reveal the styled empty
  // state once the (tucked) widget is present to host the review form.
  if (section.getAttribute('data-nrv-count') === '0') {
    var emptyWaited = 0;
    var emptyPoll = setInterval(function () {
      emptyWaited += 250;
      if (widget()) {
        clearInterval(emptyPoll);
        section.removeAttribute('data-nrv-pending');
      } else if (emptyWaited >= 8000) {
        clearInterval(emptyPoll);
        bail();
      }
    }, 250);
    return;
  }

  // Judge.me's own scroll helper bypasses scrollIntoView — same rule:
  // never scroll while the widget is tucked.
  function wrapJdgmScroll() {
    if (window.jdgm && typeof window.jdgm.scrollTo === 'function' && !window.jdgm.__nrvWrapped) {
      var orig = window.jdgm.scrollTo;
      window.jdgm.__nrvWrapped = true;
      window.jdgm.scrollTo = function () {
        if (body.classList.contains('nrv-jdgm-tucked') && !body.classList.contains('nrv-form-open')) return;
        return orig.apply(this, arguments);
      };
    }
  }

  var waited = 0;
  var poll = setInterval(function () {
    waited += 250;
    wrapJdgmScroll();
    if (attempt()) {
      clearInterval(poll);
      // observe the container, not the widget: pagination replaces the
      // widget root node, which would orphan an observer bound to it
      var host = document.querySelector('.product-app--container') || document.body;
      observer = new MutationObserver(function () { attempt(); });
      if (window.MutationObserver) observer.observe(host, { childList: true, subtree: true });
      setTimeout(preload, 1200);
    } else if (waited >= 8000) {
      clearInterval(poll);
      bail(); // widget empty or markup changed: stock widget takes over
    }
  }, 250);
})();
